import { useEffect, useState } from 'react';
import { configAPI } from '../services/api';

// 6/12-month CableTV recharge for a REGULAR customer, with the automatic box swap switched on
// (Settings → GTPL Saathi): the swap and GTPL order run the next day after 9:30 AM and the
// customer becomes DTD once the paid period ends. Mirrors backend/src/services/gtplLongTermService.js
// (onLongTermPayment) — the server is what actually does it; this only decides when to warn.
export const LONG_TERM_MONTHS = [3, 6, 12];

export const longTermRegularNoticeApplies = (automationOn, durationType, months) =>
  !!automationOn && (durationType || 'regular') === 'regular' && LONG_TERM_MONTHS.includes(Number(months));

// Whether the automatic swap is on — read once from the public /config and shared, so the
// pay screens don't each refetch it. False until known (and if the call fails): no pop-up then.
let flagPromise = null;
const loadFlag = () => {
  if (!flagPromise) {
    flagPromise = configAPI.get()
      .then((res) => !!res.data?.data?.longTermAutoStart)
      .catch(() => { flagPromise = null; return false; });
  }
  return flagPromise;
};

export function useLongTermAutoStart() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    let alive = true;
    loadFlag().then((v) => { if (alive) setOn(v); });
    return () => { alive = false; };
  }, []);
  return on;
}
